<invoice-provider-state-diff-result>

    <p>
        <span>
            {(props.normal_message) ? props.normal_message : "※発行事業者に関する情報はプロジェクト作成時点のものになります"}
        </span>
        <span
                style="color:red"
                if={ (props.invoice_provider_state !== props.invoice_provider_state_now) }
        >
            現在の情報とは異なります!!（現在：{jnames["JNAME_" + props.invoice_provider_state_now]}）
        </span>
    </p>


    <script>
        export default {
            jnames: {
                "JNAME_0": "不明",
                "JNAME_1": "不明",
                "JNAME_10": "適格請求書発行事業者以外の者",
                "JNAME_20": "適格請求書発行事業者",
            }
        };
    </script>

</invoice-provider-state-diff-result>